import { Component, EventEmitter, Input, Output } from '@angular/core'
import { Job, JobFromJSON } from 'elements-sdk'

@Component({
  selector: 'job-variables-input',
  templateUrl: './jobVariablesInput.component.pug',
  styleUrls: ['./jobVariablesInput.component.scss'],
})
export class JobVariablesInputComponent {
  @Input() vars: Record<string, any>
  @Input() job: Job
  @Output() enter = new EventEmitter<void>()

  ngOnChanges () {
    if ('input_type' in this.job) {
      this.job = JobFromJSON(this.job)
    }
  }
}
